/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const RESET_MODULES = "RESET_MODULES";
export const SET_NO_MODULE = 'SET_NO_MODULE';
export const GET_ALL_MODULES = 'GET_ALL_MODULES';
export const SET_SELECTED_MODULE = 'SET_SELECTED_MODULE';
export const SET_FILTERED_MODULES = 'SET_FILTERED_MODULES';
export const SET_AVAILABLE_MODULES = 'SET_AVAILABLE_MODULES';
export const SET_SELECTED_MODULES_LIST = 'SET_SELECTED_MODULES_LIST';